import WorkPackageV3 from '@/applications/sales/components/WorkPackageV3/WorkPackageV3'
import renderMixinMobile from '@/agilis/mobile/ListCardMobileMixins/renderMixinMobile'
import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'WorkPackageV3',
  mixins: [WorkPackageV3, renderMixinMobile],
  methods: {
    renderColumn (colId, item) {
      const colConfig = this.configuration.workpackages.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    }
  },
  computed: {
    itemLayout () {
      return this.configuration?.mobile?.workPackageItemLayout
    },
    dataTableConfigurationWP () {
      return this.configuration.workpackages
    },
    groupedItems () {
      return this.items.reduce((groups, item) => {
        const group = item[this.configuration.workpackages.grouping.column] ?? item.groupId
        if (!groups[group]) {
          groups[group] = []
        }
        groups[group].push(item)
        return groups
      }, {})
    }
  }
}
